<template>
	<div class="animated fadeIn">
		<b-card>
			<b-card-header>
			  <i class="icon-menu mr-1"></i>使用者資訊
			</b-card-header>
			<b-card-body v-if="!cannotEdit">
				<b-input-group class="mb-4">
					<!--<v-select v-model="selectMethod" :options="select_options" :value="0" placeholder="請選擇查詢方式"></v-select>-->
					<b-input-group-prepend>
						<b-input-group-text>手機號碼、UserID或電子郵件</b-input-group-text>
					</b-input-group-prepend>
					<b-form-input v-model="inputData" type="text" class="form-control" placeholder="請輸入資料" @keyup.enter="getEndUserInfoList"/>
					<b-input-group-append>
						<b-button variant="success" @click="getEndUserInfoList"><i class="fa fa-search"></i> 查詢</b-button>
					</b-input-group-append>
				</b-input-group>

				<b-card no-body>
					<div slot="header">
						<v-select v-model="selectEndUser" :options="select_end_user_options" @input="handleEndUserSelection" placeholder="請選擇使用者帳號"></v-select>
					  	<!--<i class="fa fa-user-o"></i> {{userName != '' ? userName : '未知'}} (ID:{{userId}})-->
					</div>
					<b-card-body>
						<div>
							<span class="fixed-leading" ><i class="fa fa-unlock-alt"></i></span>帳號狀態：{{userLoginFailCount == -1 ? '未知' : (userLoginFailCount >= 5 ? '鎖住' : '正常')}}
							<button v-if="userLoginFailCount >= 5" @click="unlockLogin" style="margin-left: 10px; padding: 5px 10px; border-radius: 5px; border: 1px solid #ccc; cursor: pointer;">
    							解鎖
							</button>
							<br>
						</div>
						<div>
							<span class="fixed-leading" ><i class="fa fa-unlock-alt"></i></span>DEMO：{{userDemo}}<br>
						</div>
						<div>
							<span class="fixed-leading" ><i class="fa fa-envelope-o"></i></span>Email：{{userEmail}}
							<button v-if="selectEndUser" @click="popTopEmailEditModal(userEmail)" style="margin-left: 10px; padding: 5px 10px; border-radius: 5px; border: 1px solid #ccc; cursor: pointer;">
    							編輯
							</button>
						</div>
						<div>
							<span class="fixed-leading" ><i class="fa fa-mobile"></i></span>手機號碼：{{userPhone}}<br>
						</div>
						<div>
							<span class="fixed-leading" ><i class="fa fa-mobile"></i></span>當前驗證碼：{{userValidation}}
							<button v-if="selectEndUser" @click="getEndUserVerificationCode" style="margin-left: 10px; padding: 5px 10px; border-radius: 5px; border: 1px solid #ccc; cursor: pointer;">
    							當前驗證碼
							</button>
							<br>
						</div>
						<div>
							<span class="fixed-leading" ><i class="fa fa-balance-scale"></i></span>統一編號：{{userInvoiceno != '' ? `${userInvoicenoName}(${userInvoiceno})` : ''}}<br>
						</div>
						<div>
							<span class="fixed-leading" ><i class="fa fa-barcode"></i></span>發票載具：{{userInvoiceCarrier != '' ? `${userInvoiceCarrier}` : ''}}<br>
						</div>
						<div v-if="available_car_members && available_car_members.length > 0">
							<!--<span class="fixed-leading" ><i class="fa fa-star"></i></span>車主優惠：{{getCarMembers()}}<br>-->
							<table border="0" cellpadding="3">
								<tr>
								<td style="vertical-align: top;"><span><i class="fa fa-star"></i></span></td>
								<td>車主優惠：<br><span v-html="getCarMembers()"></span></td>
								</tr>
							</table>
						</div>
						<div v-if="available_members && available_members.length > 0">
							<!--<span class="fixed-leading" ><i class="fa fa-star"></i></span>成員優惠：{{getMembers()}}<br>-->
							<table border="0" cellpadding="3">
								<tr>
								<td style="vertical-align: top;"><span><i class="fa fa-star"></i></span></td>
								<td>成員優惠：<br><span v-html="getMembers()"></span></td>
								</tr>
							</table>
						</div>
						<div v-if="available_members && available_members.length > 0" style="color: #c07711">
							
						</div>
						<span class="fixed-leading"><i class="fa fa-usd"></i></span>帳戶餘額：{{balance}}點<br>
						<span class="fixed-leading"><i class="fa fa-diamond"></i></span>紅利點數：{{bonus}}點<br>
						<div v-if="available_line && available_line.length">  
							<span class="fixed-leading"><i class="fa fa-credit-card"></i></span> 已綁定 LINE Pay
						</div>
		
						<div v-if="available_cards && available_cards.length && !available_line.length">
							<table border="0" cellpadding="3">
							<tr>
								<th colspan="6" align="center">
								<i class="fa fa-credit-card"></i> 已綁定信用卡
								</th>
							</tr>
							<tr>
								<th>卡號</th>
								<th>日期</th>
								<th class="text-center">操作</th>
							</tr>
							<tr v-for="(card, index) in available_cards" :key="card.id">
								<td>
								<span v-if="card.is_main" class="text-primary"><i class="fa fa-check"></i></span>
								<span v-else class="text-danger"><i class="fa fa-times"></i></span>
								{{`xxxx-xxxx-xxxx-${card.last4}`}}
								</td>
								<td>{{card.validate.toString().substr(2) + '/' + card.validate.toString().substr(0,2)}}</td>
								<td>
								<span v-if="card.is_main" class="text-primary pull-right">（扣款用卡）</span>
								</td>
							</tr>
							</table>
						</div>

						<div v-if="userId != ''" class="col-xs-12 col-md-12 text-center mt-3">
							<b-button variant="primary" class="center-btn-sm" @click="popTopTransactionInModal()">儲值</b-button>
						</div>
					</b-card-body>
				</b-card >

				<v-server-table :columns="endusercolumns" :data="enduserdata" :options="enduseroptions" :theme="theme" ref="enduserDataTable" id="enduserDataTable">
					<a slot="name" slot-scope="props">{{props.row.name ? props.row.name : '未知'}}</a>
					<!--<a slot="location" slot-scope="props">{{props.row.geo_location ? props.row.geo_location : props.row.lastip}}</a>-->
					<a slot="inout" slot-scope="props">
						<span class="text-primary" v-if="props.row.inout==='IN'">儲值</span>
						<span class="text-warning" v-if="props.row.inout==='OUT'">扣點</span>
					</a>
					<a slot="amount" slot-scope="props">{{props.row.amount}}點({{Math.round(props.row.amount * 1.15)}}元)</a>
					<a slot="invoicetno" slot-scope="props" class="d-inline-block text-center w-100">
						<span v-if="props.row.invoicetno && props.row.invoicetno == 'AA00000000'" class="text-danger">
							<button :disable="!showReSendInvoiceModal" @click="resendInvoice(props.row)">重開發票</button>
						</span>
						<span v-else class="text-primary">
							{{props.row.invoicetno}}
						</span>
					</a>
					<a slot="detail" slot-scope="props">{{ props.row.detail && props.row.detail.trim().startsWith('{') ? '' : props.row.detail }}</a>
					<a slot="created" slot-scope="props">{{props.row.created.substring(0, 16)}}</a>

					<div slot="child_row" slot-scope="props">
						<b-button variant="danger" class="btn-pill" size="sm" @click="TransactionDelete(props.row.id)"><i class="fa fa-trash-o"></i> 刪除</b-button> &nbsp;
					</div>
				</v-server-table>

				<v-server-table :columns="logcolumns" :data="logdata" :options="logoptions" :theme="theme" ref="logDataTable" id="logDataTable">
					<a slot="location" slot-scope="props">{{props.row.Device && props.row.Device.name ? props.row.Device.name : $t('unknow')}}</a>
					<a slot="status" slot-scope="props">
						<span class="text-primary" v-if="props.row.status==='start'">{{$t('charging')}}</span>
						<span class="text-primary" v-if="props.row.status==='stop'">{{$t('idling')}}</span>
						<span class="text-warning" v-if="props.row.status==='end'">{{$t('charging_done')}}</span>
					</a>
					<a slot="start_time" slot-scope="props">{{props.row.start_time|htime}}</a>
					<a slot="stop_time" slot-scope="props">{{props.row.stop_time|htime}}</a>
					<a slot="end_time" slot-scope="props">{{props.row.end_time|htime}}</a>
					<a slot="billing_method" slot-scope="props">{{props.row.billing_method === 'TIME' ? $t('time') : $t('kwh')}}</a>
					<a slot="interval" slot-scope="props">{{props.row.billing_method === 'TIME' ? (Math.ceil(props.row.used_time/60) + Math.ceil(props.row.used_time_peak/60)) + $t('minute') : (props.row.interval|interval) + $t('second')}}</a>
					<a slot="created" slot-scope="props">{{props.row.created.substring(0, 16)}}</a>
					<a slot="used_value" slot-scope="props">{{get_used_value(props.row)}}</a>
					<a slot="price" slot-scope="props">{{props.row.price}}/{{props.row.price_peak}}{{props.row.billing_method ==='TIME' ? $t('points_per_minute') : $t('points_per_kwh')}}</a>
					<a slot="used_time_idle" slot-scope="props">{{props.row.stop_time > 0 ? $math.floor(props.row.used_time_idle / 60 ) + '分鐘' : 'N/A'}}</a>
					<a slot="price_idle" slot-scope="props">{{props.row.stop_time > 0 ? $math.round(props.row.price_idle, 2) + '點(' + props.row.idle_info + ')': 'N/A'}}</a>
					<!-- <a slot="sub_total" slot-scope="props">{{props.row.Device.charge_first ? (props.row.Transaction && props.row.Transaction.valid ? $math.round(props.row.Device.charge_value/1.15, 2) : 0) : props.row.used_watts < 1 ? 0 : props.row.sub_total}}</a>-->
					<a slot="sub_total" slot-scope="props">{{props.row.sub_total}}</a>

					<div slot="child_row" slot-scope="props">
						<b-button variant="info" class="btn-pill" size="sm" v-if="!cannotEdit && props.row.status==='end'" @click="editChargingLogsRow(props.row.id, props.row)"><i class="fa fa-pencil"></i> 修改</b-button>
					</div>
				</v-server-table>

				<b-card no-body>
					<div slot="header">
					  <i class="fa fa-plug"></i> 隨插即充&nbsp;
					</div>
					<b-card-body>
					  <div>
						<table border="0" cellpadding="3">
						  <tr v-if="available_plug_and_charge && available_plug_and_charge.length > 0">
							<th colspan="6" align="center">
							  <i class="fa fa-car"></i> 已綁定車輛
							</th>
						  </tr>
						  <tr v-for="(pac, index) in available_plug_and_charge" :key="pac.id">
							<td>
							  <span class="text-primary"><i class="fa fa-check"></i></span>
							</td>
							<td>{{pac.idtag}}</td>
						  </tr>
						</table>
					  </div>
					</b-card-body>
				</b-card >

				<b-card no-body>
					<div slot="header">
					  <i class="fa fa-feed"></i> 感應卡&nbsp;
					</div>
					<b-card-body>
					  <div>
						<table border="0" cellpadding="3">
						  <tr v-if="available_rfid_charge && available_rfid_charge.length > 0">
							<th colspan="6" align="center">
							  <i class="fa fa-key"></i> 已綁定感應卡
							</th>
						  </tr>
						  <tr v-for="(pac, index) in available_rfid_charge" :key="pac.id">
							<td>
							  <span class="text-primary"><i class="fa fa-check"></i></span>
							</td>
							<td>{{pac.idtag}}</td>
						  </tr>
						</table>
					  </div>
					</b-card-body>
				</b-card >

				<b-card no-body>
					<div slot="header">
					  <i class="fa fa-feed"></i> 排程充電&nbsp;
					</div>
					<b-card-body>
					  <div v-for="(schedule, index) in available_schedules" :key="schedule.id">
						<b-card no-body>
						  <div slot="header">
							<i class="fa fa-clock-o"></i> {{schedule.name}}&nbsp;
							<span class="pull-right">{{schedule.enable ? '啟用' : '停用'}}</span>
						  </div>
						  <b-card-body>
							<div style="font-size: 2rem; font-weight: bold;">
							  {{schedule.start_time + '~' + schedule.end_time}}
							</div>
							<div>
							  {{ getDateWeeklyInfo(schedule) }}
							</div>
						  </b-card-body>
						</b-card >
					  </div>
					</b-card-body>
				</b-card >
			</b-card-body>
		</b-card>

		<b-modal title="Email編輯" v-model="showEmailEditModal" :hide-footer="true" :hide-header="false">
			<div>
				<b-input-group class="mb-1">
					<b-input-group-prepend>
						<b-input-group-text style="font-size: 1.2rem; height: 3rem;">Email</b-input-group-text>
					</b-input-group-prepend>
					<b-form-input 
						type="email" 
						class="form-control" 
						placeholder="Email*"
						style="font-size: 1.2rem; height: 3rem;"
						v-model.lazy.trim="$v.edit_email.$model"
						v-focus
						:state="chkState('edit_email')"
						aria-describedby="invalidEmailFeedback"/>
					<b-form-invalid-feedback id="invalidEmailFeedback">請填入有效的Email</b-form-invalid-feedback>
				</b-input-group>
			</div>
			<div class="col-xs-12 col-md-12 text-center mt-3">
				<b-button variant="primary" class="center-btn-sm" :disabled="!$v.edit_email.$dirty || $v.edit_email.$invalid" @click="EmailUpdate()">確認</b-button>
			</div>
		</b-modal>

		<b-modal title="充電紀錄編輯" v-model="showChargingLogsEditorModal" :hide-footer="true" :hide-header="false">
			<div>
				<b-input-group class="mb-1">
					<b-input-group-prepend>
						<b-input-group-text style="font-size: 1.2rem; height: 3rem;">充電紀錄編號</b-input-group-text>
					</b-input-group-prepend>
					<b-form-input 
						type="text" 
						class="form-control" 
						placeholder=""
						style="font-size: 1.2rem; height: 3rem;"
						v-model.lazy.trim="$v.edit_charging_log.id.$model"
						readonly/>
				</b-input-group>
				
				<b-input-group class="mb-1">
					<b-input-group-prepend>
						<b-input-group-text style="font-size: 1.2rem; height: 3rem;">離峰使用度數</b-input-group-text>
					</b-input-group-prepend>
					<b-form-input 
						type="text" 
						class="form-control" 
						placeholder=""
						style="font-size: 1.2rem; height: 3rem;"
						v-model.lazy.trim="$v.edit_charging_log.used_watts.$model"
						:state="chkChargingLogState('used_watts')"
						@change="calculatedSubTotal"
						aria-describedby="invalidUsedWattsFeedback"/>
					<b-form-invalid-feedback id="invalidUsedWattsFeedback">請填入度數</b-form-invalid-feedback>
				</b-input-group>

				<b-input-group class="mb-1">
					<b-input-group-prepend>
						<b-input-group-text style="font-size: 1.2rem; height: 3rem;">尖峰使用度數</b-input-group-text>
					</b-input-group-prepend>
					<b-form-input 
						type="text" 
						class="form-control" 
						placeholder=""
						style="font-size: 1.2rem; height: 3rem;"
						v-model.lazy.trim="$v.edit_charging_log.used_watts_peak.$model"
						:state="chkChargingLogState('used_watts_peak')"
						@change="calculatedSubTotal"
						aria-describedby="invalidUsedWattsPeakFeedback"/>
					<b-form-invalid-feedback id="invalidUsedWattsPeakFeedback">請填入度數</b-form-invalid-feedback>
				</b-input-group>

				<b-input-group class="mb-1">
					<b-input-group-prepend>
						<b-input-group-text style="font-size: 1.2rem; height: 3rem;">離峰使用時間(秒)</b-input-group-text>
					</b-input-group-prepend>
					<b-form-input 
						type="number" 
						class="form-control" 
						placeholder=""
						style="font-size: 1.2rem; height: 3rem;"
						v-model.lazy.trim="$v.edit_charging_log.used_time.$model"
						:state="chkChargingLogState('used_time')"
						@change="calculatedSubTotal"
						aria-describedby="invalidUsedTimeFeedback"/>
					<b-form-invalid-feedback id="invalidUsedTimeFeedback">請填入時間(秒)</b-form-invalid-feedback>
				</b-input-group>

				<b-input-group class="mb-1">
					<b-input-group-prepend>
						<b-input-group-text style="font-size: 1.2rem; height: 3rem;">尖峰使用時間(秒)</b-input-group-text>
					</b-input-group-prepend>
					<b-form-input 
						type="number" 
						class="form-control" 
						placeholder=""
						style="font-size: 1.2rem; height: 3rem;"
						v-model.lazy.trim="$v.edit_charging_log.used_time_peak.$model"
						:state="chkChargingLogState('used_time_peak')"
						@change="calculatedSubTotal"
						aria-describedby="invalidUsedTimePeakFeedback"/>
					<b-form-invalid-feedback id="invalidUsedTimePeakFeedback">請填入時間(秒)</b-form-invalid-feedback>
				</b-input-group>

				<b-input-group class="mb-1">
					<b-input-group-prepend>
						<b-input-group-text style="font-size: 1.2rem; height: 3rem;">佔位時間(包含免費佔位時間)(分鐘)</b-input-group-text>
					</b-input-group-prepend>
					<b-form-input 
						type="number" 
						class="form-control" 
						placeholder=""
						style="font-size: 1.2rem; height: 3rem;"
						v-model.lazy.trim="$v.edit_charging_log.used_time_idle.$model"
						:state="chkChargingLogState('used_time_idle')"
						@change="calculatedSubTotal"
						aria-describedby="invalidUsedTimeIdleFeedback"/>
					<b-form-invalid-feedback id="invalidUsedTimeIdleFeedback">請填入佔位時間(分鐘)</b-form-invalid-feedback>
				</b-input-group>

				<b-input-group class="mb-1">
					<b-input-group-prepend>
						<b-input-group-text style="font-size: 1.2rem; height: 3rem;">使用點數(點)</b-input-group-text>
					</b-input-group-prepend>
					<b-form-input 
						type="text" 
						class="form-control" 
						placeholder=""
						style="font-size: 1.2rem; height: 3rem;"
						v-model.lazy.trim="$v.edit_charging_log.sub_total.$model"
						readonly/>
				</b-input-group>
			</div>
			<div class="col-xs-12 col-md-12 text-center mt-3">
				<b-button variant="primary" class="center-btn-sm" :disabled="$v.edit_charging_log.$invalid" @click="ChargingLogsUpdate()">確認</b-button>
			</div>
		</b-modal>

		<b-modal title="儲值" v-model="showTransactionInModal" :hide-footer="true" :hide-header="false">
			<div>
			  <b-input-group class="mb-1">
				<b-input-group-prepend>
				  <b-input-group-text style="font-size: 1.2rem; height: 3rem;">儲值金額</b-input-group-text>
				</b-input-group-prepend>
				<b-form-input
				ref="amount_in"
				class="text-center"
				autocomplete="off"
				v-model="amount_in"
				type="number"
				style="font-size: 1.2rem; height: 3rem;"
				placeholder="請填入儲值金額"/>
			  </b-input-group>
			  <b-input-group class="mb-2">
				<b-input-group-prepend>
				  <b-input-group-text style="font-size: 1.2rem; height: 3rem;">紅利點數</b-input-group-text>
				</b-input-group-prepend>
				<b-form-input
				ref="bonus_in"
				class="text-center"
				autocomplete="off"
				v-model="bonus_in"
				type="number"
				style="font-size: 1.2rem; height: 3rem;"
				placeholder="請填入紅利點數"/>
			  </b-input-group>
			</div>
			<div v-if="userId != ''" class="col-xs-12 col-md-12 text-center mt-3">
				<b-button variant="primary" class="center-btn-sm" @click="TransactionIn(userId)">確認</b-button>
			</div>
		</b-modal>

		<b-modal title="錯誤訊息" v-model="showErrorModal" ok-title="確定" :ok-only="true">
	    	<b-alert :show="showErrorModal" variant="danger"><i class="fa fa-exclamation-triangle"></i> {{errorMsg}}</b-alert>
		</b-modal>

		<b-modal title="發票處理中" v-model="showReSendInvoiceModal" :hide-footer="true" :hide-header="true" :no-close-on-esc="true" :no-close-on-backdrop="true">
			<h3>發票開立中，請稍候</h3>
		</b-modal>
	</div>
</template>

<script>
import { required, minLength, between, email, sameAs, maxLength, integer } from 'vuelidate/lib/validators'
import Vue from 'vue'
import {ServerTable, Event} from 'vue-tables-2'
import vSelect from 'vue-select'
import config from '@/config/global'
import notifications from '@/config/notifications'
import moment from 'moment-timezone'

Vue.use(ServerTable)

const encrypt  = config.encrypt;
const decrypt  = config.decrypt;
const admin_root = config.admin_root;
const api_root = config.api_root;

const generateRandomToken = () => {
  // 使用 36 進位，並串接兩個隨機數來增加長度
  const part1 = Math.random().toString(36).slice(2).toUpperCase();
  const part2 = Math.random().toString(36).slice(2).toUpperCase();
  const part3 = Math.random().toString(36).slice(2).toUpperCase();
  return `${part1}${part2}${part3}`; 
};

export default {
	name: 'EndUserInfo',
	components: {
		vSelect,
		ServerTable,
		Event,
	},
	notifications,
	data(){
    	let app = this;
		let cannotEdit = app.$state.$get('ccff') === 'N/A' ? false : true;

		return {
			cannotEdit,
			edit_email: '',
			edit_charging_log: {
				id: null,
				used_watts: '0.000', // 建議初始值也符合格式
				used_watts_peak: '0.000',
				used_time: 0,
				used_time_peak: 0,
				used_time_idle: 0,
				sub_total: '0.00'
			},
			showChargingLogsEditorModal: false,
			selected_row: null,
			theme: '',
			selectEndUser: null,
			select_end_user_options: [],
			inputData: null,
			balance: 0,
      		bonus: 0,
			amount_in: 0,
			bonus_in: 0,
			userLoginFailCount: -1,
			userDemo: '',
			userId: '',
			userName: '',
			userPhone: '',
			userValidation: '',
			userDefaultEmail:'',
			userEmail: '',
			userInvoiceno: '',
			userInvoicenoName: '',
			userInvoiceCarrier: '',
			available_end_users: [],
			available_car_members: [],
			available_cards: [],
      		available_line: [],
			available_members: [],
			available_plug_and_charge:[],
			available_rfid_charge:[],
			available_schedules:[],
			enduserdata: [],
			logdata: [],
			start_time:'',
			end_time:'',
			showErrorModal: false,
			showCameraModal: false,
			showTransactionInModal: false,
			showReSendInvoiceModal: false,
			showEmailEditModal: false,
			errorMsg:'',
			endusercolumns: ['id','inout', 'amount', 'bonus', 'name', 'invoicetno', 'buyerubn', 'detail', 'created'],
			enduseroptions: {
				headings: {
					// company_id: '公司',
					id: '交易序號',
					name: '地點',
					inout: '類型',
					bonus: '紅利點數',
					amount: '交易點數',
					invoicetno: '發票號碼',
					buyerubn: '統編',
					detail: '備註',
					created: '建立時間'
				},
				orderBy: {
					column: 'created',
					ascending: false
				},
				sortable: [],
				filterable: [],
				sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
				pagination: {
					chunk: 5,
					edge: false,
					nav: 'scroll'
				},
				perPage: 25,
				requestFunction(data) {
					//console.info('app.userId:', app.userId);
					let action = `${config.admin_root}/get_transaction_records`;
					let params = {
					    user_id: encodeURIComponent(config.encrypt(app.userId.toString(), config.ffkey, config.ffiv)),
						keyset: 'mqtt'
					};

					let ccff = this.$state.$get('ccff');
					if(ccff){
						params['ccff'] = ccff;
					}

					for(let col in data){
						params[col] = data[col];
					}

					return fetch(action, {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json',
							'Authorization': 'Bearer ' + this.$state.$get('adminuser').token
						},
						body: JSON.stringify(params)
					}).then(res => res.json()).then(result => {
						return {
							data: result.data || [],
							count: result.count || 0
						};
					}).catch(error => {
						return {
							data: [],
							count: 0
						};
					});
				}//eo requestFunction
			},
			logcolumns: ['location', 'start_time', 'stop_time', 'end_time', 'status', 'billing_method', 'interval', 'used_value', 'price', 'used_time_idle', 'price_idle', 'sub_total'],
			logoptions: {
				headings: {
					// company_id: '公司',
					location: this.$t('user_history.logoptions.location'),
					start_time: this.$t('user_history.logoptions.start_time'),
					stop_time: this.$t('user_history.logoptions.stop_time'),
					end_time: this.$t('user_history.logoptions.end_time'),
					status: this.$t('user_history.logoptions.status'),
					billing_method: this.$t('user_history.logoptions.billing_method'),
					interval: this.$t('user_history.logoptions.interval'),
					used_value: this.$t('user_history.logoptions.used_value'),
					price: this.$t('user_history.logoptions.price'),
					used_time_idle: this.$t('user_history.logoptions.used_time_idle'),
					price_idle: this.$t('user_history.logoptions.price_idle'),
					sub_total: this.$t('user_history.logoptions.sub_total'),
					// created: '紀錄'
				},
				orderBy: {
					column: 'created',
					ascending: false
				},
				sortable: [],
				filterable: [],
				sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
				pagination: {
					chunk: 5,
					edge: false,
					nav: 'scroll'
				},
				perPage: 25,
				requestFunction(data) {
					//console.info('app.userId:', app.userId);
					let action = `${config.admin_root}/get_charging_records`;
					let params = {
						user_id: encodeURIComponent(config.encrypt(app.userId.toString(), config.ffkey, config.ffiv)),
						keyset: 'mqtt'
					};

					let ccff = this.$state.$get('ccff');
					if(ccff){
						params['ccff'] = ccff;
					}

					for(let col in data){
						params[col] = data[col];
					}

					return fetch(action, {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json',
							'Authorization': 'Bearer ' + this.$state.$get('adminuser').token
						},
						body: JSON.stringify(params)
					}).then(res => res.json()).then(result => {
						return {
							data: result.data || [],
							count: result.count || 0
						};
					}).catch(error => {
						return {
							data: [],
							count: 0
						};
					});
				}//eo requestFunction
			},
      		cameraDevices: [],
		}
	},//eo data
  	created() {
  	},

	mounted() {
	},//eo mounted

	methods: {
		gotoPage(page) {
		// console.info('new page: ', page);
			this.$refs.enduserDataTable.setPage(page);
		},
		chkState(val) {
			const field = this.$v[val];
			return !field.$dirty || !field.$invalid;
		},
		chkChargingLogState(val) {
			const field = this.$v.edit_charging_log[val];
			return !field.$dirty || !field.$invalid;
		},
		calculatedSubTotal() {
			let app = this;

			if (this.$v.edit_charging_log.$invalid) {
				return false;
			}

			let billing_method = this.selected_row.billing_method;
			let idle_info = this.selected_row.idle_info;
			let used_watts = parseFloat(this.edit_charging_log.used_watts);
			let used_watts_peak = parseFloat(this.edit_charging_log.used_watts_peak);
			let used_time = parseInt(this.edit_charging_log.used_time);
			let used_time_peak = parseFloat(this.edit_charging_log.used_time_peak);
			let used_time_idle = parseFloat(this.edit_charging_log.used_time_idle) * 60;
			let price = parseFloat(this.selected_row.price);
			let price_peak = parseFloat(this.selected_row.price_peak);
			let price_idle = parseFloat(this.selected_row.price_idle);

			let sub_total = 0.0;
			if(billing_method === 'TIME') {
				sub_total = Math.ceil(used_time/60) * price + Math.ceil(used_time_peak/60) * price_peak;
			} else {
				sub_total = used_watts * price + used_watts_peak * price_peak;
			}

			let total_pay_idle = 0.00;
			let [idle_free_period, idle_interval_rate, idle_max_price] = idle_info.split('/');
			idle_free_period = parseInt(idle_free_period); //min
			idle_interval_rate = parseInt(idle_interval_rate); //min
			idle_max_price = parseFloat(idle_max_price); //points
			let idle_free_period_sec = idle_free_period * 60; //sec
			//let idle_interval_rate_sec = idle_interval_rate * 60; //sec
			let idle_time = used_time_idle - idle_free_period_sec; //sec

			if(price_idle > 0.00) {
				total_pay_idle = (idle_interval_rate == 0 || idle_time <= 0) ? 0.00 : Math.round(Math.ceil(Math.floor(idle_time/60) / idle_interval_rate) * price_idle * 100) / 100;
				if(idle_max_price > 0 && total_pay_idle > idle_max_price) {
					total_pay_idle = idle_max_price;
				}
				sub_total += total_pay_idle;
			}
			if(sub_total !== NaN) {
				this.edit_charging_log.sub_total = sub_total.toFixed(2);
			}
			//console.info('sub_total:', sub_total.toFixed(2));
		},
		editChargingLogsRow(row_id, row) {
			this.$v.edit_charging_log.$reset();
			//console.info('row:', row);
			this.selected_row = row;
			this.edit_charging_log.id       = row.id;
			this.edit_charging_log.used_watts = row.used_watts;
			this.edit_charging_log.used_watts_peak = row.used_watts_peak;
			this.edit_charging_log.used_time = row.used_time;
			this.edit_charging_log.used_time_peak = row.used_time_peak;
			this.edit_charging_log.used_time_idle = Math.floor(row.used_time_idle / 60 );
			this.edit_charging_log.sub_total = row.sub_total;
			this.showChargingLogsEditorModal = true;
		},//eo editRow
		ChargingLogsUpdate() {
			let app    = this;
			this.$v.edit_charging_log.$touch();

			if (this.$v.edit_charging_log.$invalid) {
				this.showError({message:'請輸入必填欄位', title:'資料錯誤'});
				return false;
			}

			let to_save = {
				id: app.edit_charging_log.id,
				used_watts: parseFloat(app.edit_charging_log.used_watts).toFixed(3),
				used_watts_peak: parseFloat(app.edit_charging_log.used_watts_peak).toFixed(3),
				used_time: app.edit_charging_log.used_time,
				used_time_peak: app.edit_charging_log.used_time_peak,
				used_time_idle: app.edit_charging_log.used_time_idle * 60,
				sub_total: app.edit_charging_log.sub_total,
			};
			//console.info('to_save:', to_save);

			to_save = encodeURIComponent(encrypt(JSON.stringify(to_save)));

		    let action = `${admin_root}/save_charging_log`;
		    let params = {
		    	keyset: 'mqtt',
		    	record: to_save
		    };

			fetch(action, {
				method: 'POST',
				headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + this.$state.$get('adminuser').token
				},
				body: JSON.stringify(params)
			}).then(res => res.json()).then(result => {
				if(result.success){
					app.showSuccess({
						title: '成功',
						message: '資料成功儲存'
					});
					this.showChargingLogsEditorModal = false;
					app.$refs['logDataTable'].refresh();
				} else {
					app.showError({
						title: '錯誤',
						message: '無法儲存資料，請稍後再試'
					});
					app.$refs['logDataTable'].refresh();
				}
			}).catch(error => {
				app.showError({
					title: '錯誤',
					message: '無法儲存資料，請稍後再試'
				});
				app.$refs['logDataTable'].refresh();
			});
		},
		get_used_value(row) {
			let used_value = '0.000/0.000' + this.$t('unit_kwh');
			if(row) {
				if(row.billing_method == 'TIME') {
					if((parseFloat(row.used_watts) + parseFloat(row.used_watts_peak)) > 0.2){
						used_value = Math.ceil(row.used_time/60) + '/' + Math.ceil(row.used_time_peak/60) + this.$t('minute') + '_' + row.used_watts + '/' + row.used_watts_peak + this.$t('unit_kwh');
					} else {
						used_value = '0/0' + this.$t('minute') + '_' + row.used_watts + '/' + row.used_watts_peak + this.$t('unit_kwh');
					}
				} else {
					used_value = row.used_watts + '/' + row.used_watts_peak + this.$t('unit_kwh');
				}
			}
			return used_value;
		},//eo get_used_value
		end_user_clear(){
			let app = this;
			app.balance = 0;
            app.bonus = 0;
			app.userLoginFailCount = -1;
			app.userDemo='';
			app.userId='';
			app.userName='';
			app.userPhone='';
			app.userValidation='';
			app.userDefaultEmail='';
			app.userEmail='';
			app.userInvoiceno='';
			app.userInvoicenoName='';
			app.userInvoiceCarrier='';
			app.available_car_members=[];
			app.available_cards=[];
			app.available_line=[];
			app.available_members=[];
			app.available_plug_and_charge=[];
			app.available_rfid_charge=[];
			app.available_schedules=[];
			app.edit_email = '';
		},
		handleEndUserSelection(data){
			let app = this;
			//console.info('data', data);
			app.end_user_clear();
			if(data != null) {
				app.getEndUserInfo(data.user_id);
			} else {
				app.$refs['enduserDataTable'].refresh();
				app.$refs['logDataTable'].refresh();
				app.readLoginFailCount();
			}
		},
		getEndUserInfoList() {
			let app = this;
			app.available_end_users=[];
			app.selectEndUser=null;
			app.select_end_user_options=[];

			if(app.inputData != null ) {
				let request_data = {
					method: 0,
					data: app.inputData ? app.inputData : null,
				};
				request_data = encodeURIComponent(config.encrypt(JSON.stringify(request_data), config.ffkey, config.ffiv));

				let after = (google_captcha) => {
					let action = `${config.admin_root}/get_end_user_info_list`;
					fetch(action, {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json',
							'Authorization': 'Bearer ' + this.$state.$get('adminuser').token
						},
						body: JSON.stringify({
							request: request_data,
							ggtoken: google_captcha
						})
					}).then(res => res.json()).then(result => {
						//console.info('getEndUserInfoList:', result);
						if(result.success){
							if(result.found_end_users) {
								app.available_end_users = result.found_end_users;

								app.available_end_users.forEach((end_user, index) => {
									let type = (end_user.email && end_user.email.indexOf('@') !== -1) ? '會員註冊' : '手機註冊';
									let option = {label:`[${type}] ${end_user.name} (ID:${end_user.id})`, index: index, user_id: end_user.id};
									app.select_end_user_options.push(option);
								});

								if(app.available_end_users && app.available_end_users.length) {
									app.selectEndUser = app.select_end_user_options[0];
									/*app.$nextTick(() => {//default select 
										app.selectEndUser = app.select_end_user_options[0];
									});*/
								}
							}
						}
					}).catch(error => {
					});
				}

				grecaptcha.execute(config.captcha_key, {action: 'enduserinfolist'}).then(function(ggtoken) {
					// console.info('grecaptcha.token:', ggtoken);
					after(ggtoken);
				});
			} 
		},
		getEndUserInfo(user_id) {
			let app = this;
			if(user_id != null ) {
				let request_data = {
					user_id,
				};
				request_data = encodeURIComponent(config.encrypt(JSON.stringify(request_data), config.ffkey, config.ffiv));
				let after = (google_captcha) => {
					let action = `${config.admin_root}/get_end_user_info`;
					fetch(action, {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json',
							'Authorization': 'Bearer ' + this.$state.$get('adminuser').token
						},
						body: JSON.stringify({
							request: request_data,
							ggtoken: google_captcha
						})
					}).then(res => res.json()).then(result => {
						//console.info('getEndUserInfo:', result);
						if(result.success){
							if(result.user) {
								let end_user = result.user;
								app.balance = parseInt(end_user.credits);
								app.bonus = parseInt(end_user.bonus);
								app.userDemo=end_user.demo;
								app.userId=end_user.id;
								app.userName=end_user.name;
								app.userPhone=end_user.phone;
								app.userDefaultEmail=end_user.email;
								if(end_user.email.indexOf('@') !== -1) { //email login user.
									app.userEmail = end_user.email2 ? end_user.email2 : end_user.email;	
								} else { //phone login user
									app.userEmail = end_user.email2 ? end_user.email2 : '';
								}
								app.userInvoiceno=end_user.invoiceno;
								app.userInvoicenoName=end_user.invoiceno_name;
								app.userInvoiceCarrier=end_user.invoice_carrier;
								app.available_car_members=[];
								app.available_cards=[];
								app.available_line=[];
								app.available_members=[];
								app.available_plug_and_charge=[];
								app.available_rfid_charge=[];

								if (end_user.cards) {
									app.available_cards = end_user.cards;
								} else {
									app.available_cards = [];
								}

								if (end_user.line) {
									app.available_line = end_user.line;
								} else {
									app.available_line = [];
								}

								if (end_user.car_members) {
									app.available_car_members = end_user.car_members;
								} else {
									app.available_car_members = [];
								}

								if (end_user.members) {
									app.available_members = end_user.members;
								} else {
									app.available_members = [];
								}

								if (end_user.plug_and_charge) {
									app.available_plug_and_charge = end_user.plug_and_charge;
								} else {
									app.available_plug_and_charge = [];
								}

								if (end_user.rfid_charge) {
									app.available_rfid_charge = end_user.rfid_charge;
								} else {
									app.available_rfid_charge = [];
								}

								if (end_user.schedules) {
									//console.info('schedules: ', result.user.schedules);
									app.available_schedules = end_user.schedules;
									app.available_schedules.forEach((schedule, index) => {
										schedule.name = schedule.Device ? schedule.Device.name : '未知裝置';
										schedule.start_time = schedule.start_time.substring(0, 5);
										schedule.end_time = schedule.end_time.substring(0, 5);    
									});
								} else {
									app.available_schedules = [];
								}	
							}
						}
						app.$refs['enduserDataTable'].refresh();
						app.$refs['logDataTable'].refresh();
						app.readLoginFailCount();
					}).catch(error => {
					});
				}

				grecaptcha.execute(config.captcha_key, {action: 'enduserinfo'}).then(function(ggtoken) {
					// console.info('grecaptcha.token:', ggtoken);
					after(ggtoken);
				});
			} 
		},
		TransactionDelete(transaction_id) {
			let app = this;
			if(transaction_id != null) {
				let msg = `您確定要刪除交易序號:${transaction_id} 嗎？`;
				if (window.confirm(msg)) {
					let request_data = {
						transaction_id,
					};
					request_data = encodeURIComponent(config.encrypt(JSON.stringify(request_data), config.ffkey, config.ffiv));

					let action = `${config.admin_root}/transaction_delete`;
					fetch(action, {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json',
							'Authorization': 'Bearer ' + this.$state.$get('adminuser').token
						},
						body: JSON.stringify({
							request: request_data
						})
					}).then(res => res.json()).then(result => {
						//console.info('TransactionDelete:', result);
						if(result.success){
							this.showSuccess({
							message: `交易序號:${transaction_id} 刪除成功`,
							});
							app.handleEndUserSelection(app.selectEndUser);
						} else {
							this.showError({
							message: `交易序號:${transaction_id} 刪除失敗。錯誤訊息:${result.message}`,
							}); 
						}
					}).catch(error => {
						this.showError({
						message: `交易序號:${transaction_id} 刪除失敗。錯誤訊息:${error}`,
						}); 
					});
				}
			}
		},
		TransactionIn(user_id) {
			let app = this;
			//console.info('user_id:', user_id);
			if(user_id != null && (app.amount_in != 0 || app.bonus_in != 0)) {
				let request_data = {
					user_id,
					amount: app.amount_in,
					bonus: app.bonus_in,
				};
				request_data = encodeURIComponent(config.encrypt(JSON.stringify(request_data), config.ffkey, config.ffiv));

				let action = `${config.admin_root}/transaction_in`;
				fetch(action, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						'Authorization': 'Bearer ' + this.$state.$get('adminuser').token
					},
					body: JSON.stringify({
						request: request_data
					})
				}).then(res => res.json()).then(result => {
					//console.info('TransactionIn:', result);
					if(result.success){
						this.showSuccess({
						message: `儲值成功`,
						});
						this.showTransactionInModal = false;
						app.handleEndUserSelection(app.selectEndUser);
					} else {
						this.showError({
						message: `儲值失敗。錯誤訊息:${result.message}`,
						}); 
					}
				}).catch(error => {
					this.showError({
					message: `儲值失敗。錯誤訊息:${error}`,
					}); 
				});
			}
		},
		popTopEmailEditModal(email){
			this.edit_email = email;
			this.showEmailEditModal = true;
			// 延遲一點點等 modal 綁定完畢再觸發驗證
			this.$nextTick(() => {
				this.$v.edit_email.$touch();  // 標記為 dirty 並執行驗證
			});
		},//eo popTopEmailEditModal
		EmailUpdate() {
			let app = this;
			this.$v.edit_email.$touch();

			if (this.$v.edit_email.$invalid) {
				this.showError({message:"請填入有效的Email", timeout: 1000});
				return false;
			}

			if(this.userId != '' && this.edit_email != '') {
				let request_data = {
					user_id: this.userId,
					email: this.edit_email,
				};
				request_data = encodeURIComponent(config.encrypt(JSON.stringify(request_data), config.ffkey, config.ffiv));

				let action = `${config.admin_root}/email_update`;
				fetch(action, {
					method: 'POST',
					headers: {
					'Content-Type': 'application/json',
					'Authorization': 'Bearer ' + this.$state.$get('adminuser').token
					},
					body: JSON.stringify({
						request: request_data
					})
				}).then(res => res.json()).then(result => {
					if(result.success){
						this.showSuccess({
						message: `更新成功`,
						});
						this.showEmailEditModal = false;
						app.handleEndUserSelection(app.selectEndUser);
					} else {
						this.showError({
						message: `更新失敗。錯誤訊息:${result.message}`,
						}); 
					}
				}).catch(error => {
				});
			}
		},
		getCarMembers(){
			let car_members = '';
			if(this.available_car_members) {
				//console.log('this.available_car_members:' , this.available_car_members);
				this.available_car_members.forEach((car_member, index) => {
					let validity_period_date = car_member['validity_period_date'];
					let discount = parseFloat(car_member['discount']);
					//console.log('discount:' , discount);
					if(discount != 1.00) {
						car_members += `[${car_member['cardno']}]` + car_member['car_brand'];
						if(discount == 0.00) {
							car_members += `(免費)`;
						} else {
							car_members += `(${(discount * 10).toString().replace(/\.0$/, '')}折)`;
						}
						if(validity_period_date) {
							car_members += `(有效期限:${validity_period_date})`;
						}
						car_members += '<br>';
					}
				});
			}
			return car_members;
		},
		getMembers(){
			let members = '';
			if(this.available_members) {
				//console.log('this.available_members:' , this.available_members);
				this.available_members.forEach((member, index) => {
					let validity_period_date = member['validity_period_date'];
					let validity_period_date_start = member['validity_period_date_start'];
					if(member['type'] == 'REWARD') {
						let reward = parseFloat(member['reward']);
						if(reward != 0.00) {
							members += `[${member['cardno']}]` + `全站充電回饋${reward * 100}%`;
							if(validity_period_date) {
								members += `(有效期限:${validity_period_date_start} ~ ${validity_period_date})`;
							}
							members += '<br>'
						}
					} else {
						let discount = parseFloat(member['discount']);
						//console.log('discount:' , discount);
						if(discount != 1.00) {
							members += `[${member['cardno']}]` + member['Company.name'];
							if(discount == 0.00) {
								members += `(免費)`;
							} else {
								members += `(${(discount * 10).toString().replace(/\.0$/, '')}折)`;
							}
							if(validity_period_date) {
								members += `(有效期限:${validity_period_date})`;
							}
							members += '<br>';
						}
					}
				});
			}
			return members;
		},
		getDateWeeklyInfo(schedule){
			let info = '';
			if(schedule) {
				if(schedule.date != null) { //show date and week info
				info = this.getDateAndWeekInfo(schedule.date);
				} else { //show weekly info
				info = this.getWeeklyInfo(schedule.weekly);
				}
			}
			return info;
		},
		getDateAndWeekInfo(date){
			let info = '';
			if(date) {
				let dateObject = moment(date).tz(config.timezone);
				let dateObjectYear = dateObject.format("YYYY");
				let dateObjectMonth = dateObject.format("MM");
				let dateObjectDay = dateObject.format("DD");
				let today = moment().tz(config.timezone);
				let todayYear = today.format("YYYY");
				let todayMonth = today.format("MM");
				let todayDay = today.format("DD");
				let tomorrowDay = today.add(1, 'day').format("DD");

				//console.log('dateObjectYear:' , dateObjectYear, ', dateObjectMonth:' , dateObjectMonth, ', dateObjectDay:' , dateObjectDay);
				//console.log('todayYear:' , todayYear, ', todayMonth:' , todayMonth, ', todayDay:' , todayDay);

				if(dateObjectYear === todayYear && dateObjectMonth === todayMonth) {
					if(dateObjectDay === todayDay) {
						info += '今天-';
					} else if(dateObjectDay === tomorrowDay) {
						info += '明天-';
					}
				}

				info += dateObject.format("MM").toString() + '月' + dateObject.format("DD").toString() + '日';
				let dayOfWeekString = dateObject.format("d");
				let dayOfWeek = parseInt(dayOfWeekString);
				//console.log('dayOfWeek:' , dayOfWeek);
				let day;
				switch(dayOfWeek) {
					case 0:
						day = "週日";
						break;
					case 1:
						day = "週一";
						break;
					case 2:
						day = "週二";
						break;
					case 3:
						day = "週三";
						break;
					case 4:
						day = "週四";
						break;
					case 5:
						day = "週五";
						break;
					case 6:
						day = "週六";
						break;
					default:
						day = "無效日期";
						break;
				}
				info += ', ' + day;
			}
			return info;
		},
		getWeeklyInfo(weekly){
			let info = '';
			if(weekly) {
				if(weekly == 127) {
					info = '每天';
				} else {
					//show weekly info
					let sun = weekly & 64;
					let mon = weekly & 32;
					let tue = weekly & 16;
					let wed = weekly & 8;
					let thu = weekly & 4;
					let fri = weekly & 2;
					let sat = weekly & 1;

					info = '每 ';
					if(sun) {
						info += '週日 ';
					}
					if(mon) {
						info += '週一 ';
					}
					if(tue) {
						info += '週二 ';
					}
					if(wed) {
						info += '週三 ';
					}
					if(thu) {
						info += '週四 ';
					}
					if(fri) {
						info += '週五 ';
					}
					if(sat) {
						info += '週六 ';
					}
				}
			}
			return info;
		},
		popTopTransactionInModal(){
			this.amount_in = 0;
			this.bonus_in = 0;
			this.showTransactionInModal = true;
		},//eo popTopTransactionInModal
		getEndUserVerificationCode(){
			let app = this;
			app.userValidation = '';
			if(app.userDefaultEmail != '') {
				let request_data = {
					email: app.userDefaultEmail,
				};
				request_data = encodeURIComponent(config.encrypt(JSON.stringify(request_data), config.ffkey, config.ffiv));

				let action = `${config.admin_root}/get_end_user_validation_code`;
				fetch(action, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						'Authorization': 'Bearer ' + this.$state.$get('adminuser').token
					},
					body: JSON.stringify({
						request: request_data
					})
				}).then(res => res.json()).then(result => {
					if(result.success){
						if(result.validation) {
							app.userValidation = `${result.validation.token}(${result.validation.created})`
						}
					}
				}).catch(error => {
				});
			}
		},
		readLoginFailCount(){
			let app = this;
			if(app.userDefaultEmail != '') {
				let action = `${api_root}/enduser/read_login_fail_count`;
				fetch(action, {
					method: 'POST',
					headers: {
					'Content-Type': 'application/json',
					'Authorization': 'Bearer ' + this.$state.$get('adminuser').token
					},
					body: JSON.stringify({
						keyset: 'mqtt',
						access: encodeURIComponent(encrypt(app.userDefaultEmail)),
					})
				}).then(res => res.json()).then(result => {
					if(result.success){
						app.userLoginFailCount = result.login_fail_count;
					}
				}).catch(error => {
				});
			}
		},
		unlockLogin(){
			let app = this;
			if(app.userDefaultEmail != '' && app.userLoginFailCount >= 5) {
				let action = `${api_root}/enduser/reset_user_login_fail`;
				fetch(action, {
					method: 'POST',
					headers: {
					'Content-Type': 'application/json',
					'Authorization': 'Bearer ' + this.$state.$get('adminuser').token
					},
					body: JSON.stringify({
						keyset: 'mqtt',
						access: encodeURIComponent(encrypt(app.userDefaultEmail)),
					})
				}).then(res => res.json()).then(result => {
					app.readLoginFailCount();
				}).catch(error => {
					app.readLoginFailCount();
				});
			}
		},
		resendInvoice(row) {
			let app    = this;
			let data = {
				id: row.id,
				user_id: app.userId,
				invoicetransno: row.invoicetransno
			};

			data = encodeURIComponent(encrypt(JSON.stringify(data)));

			let action = `${config.admin_root}/resend_invoice`;
			let params = {
				keyset: 'mqtt',
				data: data
			};

			app.showReSendInvoiceModal = true;
			fetch(action, {
				method: 'POST',
				headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + this.$state.$get('adminuser').token
				},
				body: JSON.stringify(params)
			}).then(res => res.json()).then(result => {
				if(result.success){
					app.showReSendInvoiceModal = false;
					app.showSuccess({
						title: '成功',
						message: '發票開立成功'
					});
					
					//app.$refs['enduserDataTable'].refresh();
					const currentPage = app.$refs.enduserDataTable.page;
					// 使用Vue.nextTick確保DOM更新完成
					app.$nextTick(() => {
						// 設置回之前的頁碼(此會重新請求數據)
						app.$refs.enduserDataTable.setPage(currentPage);
					});
				} else {
					app.showReSendInvoiceModal = false;
					app.showError({
						title: '失敗',
						message: '發票開立失敗'
					});
					//app.$refs['enduserDataTable'].refresh();
				}
			}).catch(error => {
				app.showReSendInvoiceModal = false;
				app.showError({
					title: '錯誤',
					message: `發票開立錯誤。Error:${error}`
				});
				//app.$refs['enduserDataTable'].refresh();
			});
        },
	},//eo methods
	validations: {
		edit_email: {
			email,
			required,
			minLength: minLength(4)
		},
		edit_charging_log: {
			id: {
				required,
				integer,
			},
			used_watts: {
				required,
				validFormat(value) {
					// 正則解釋：
					// ^\d+ : 以一個或多個數字開始（整數部分）
					// (\.\d{1,3})? : 
					//    \.     -> 匹配小數點
					//    \d{1,3} -> 後面接 1 到 3 位數字
					//    (...)? -> 括號內這一組（點+小數）是選填的
					// $ : 結束
					return /^\d+(\.\d{1,3})?$/.test(value);
				}
			},
			used_watts_peak: {
				required,
				validFormat(value) {
					// 正則解釋：
					// ^\d+ : 以一個或多個數字開始（整數部分）
					// (\.\d{1,3})? : 
					//    \.     -> 匹配小數點
					//    \d{1,3} -> 後面接 1 到 3 位數字
					//    (...)? -> 括號內這一組（點+小數）是選填的
					// $ : 結束
					return /^\d+(\.\d{1,3})?$/.test(value);
				}
			},
			used_time: {
				required,
				integer,
			},
			used_time_peak: {
				required,
				integer,
			},
			used_time_idle: {
				required,
				integer
			},
			sub_total: {
				required,
			},
		}
	}//eo validations
}
</script>

<style>
.breadcrumb{display: none;}
.pt-3, .py-3 { padding-top: 0.35rem !important; }
.VueTables__search-field label, .VueTables__limit-field label{
	display: none;
	width: 0px;
}
.VueTables__child-row-toggler {
	width: 16px;
	height: 16px;
	line-height: 16px;
	display: block;
	margin: auto;
	text-align: center;
}
.VueTables__child-row-toggler--closed::before {
	content: "+";
}
.VueTables__child-row-toggler--open::before {
	content: "-";
}
.fixed-leading{
	display: inline-block;
	width: 1.3rem;
	text-align: center;
}
.center-btn-sm{
	display: flex;
	align-items: center;
	justify-content: center;
	height: 2rem;
	max-width: 98%;
	min-width: 98%;
	font-size: 1rem;
	margin: 0.5px 0px;
}
.top-up-btn-sm{
	height: 3rem;
	max-width: 98%;
	min-width: 98%;
	font-size: 1.5rem;
	margin: 0.5px 0px;
}
</style>

<style src="spinkit/scss/spinkit.scss" lang="scss" />